module.exports = __webpack_public_path__ + "static/media/location@2x.abce4687.png";